module.exports = __webpack_public_path__ + "img/ws.04c60bca.svg";